export const GesundheitsplattformTheme = {
  name: 'Gesundheitsplattform Theme',
  themeId: 'gesundheitsplattform',
  colors: {
    brand: {
      primary: {
        100: '#0099A6'
      },
      secondary: {
        100: '#00838F'
      },
      accent: {
        100: '#0099A6'
      },
      alternative: {
        100: '#008274'
      }
    }
  },
  backgrounds: {
    tile: '#0099A6'
  },
  fonts: {
    families: {
      text: '"Proxima N W01 Reg", "Helvetica Neue", "Helvetica", arial, sans-serif',
      condensed: '"Proxima N W01 Bold", "Helvetica Neue Condensed", "Impact", arial, sans-serif',
      heading: '"Proxima N W01 Bold", "Helvetica Neue", "Helvetica", arial, sans-serif',
      subHeading: '"Proxima N W01 Smbd", "Helvetica Neue", "Helvetica", arial, sans-serif'
    }
  }
};